import axios from "axios";
import moment from "moment";
import { config } from "../../../../../enviroment";

export const paymentService = {
  postPaymentProcessing,
  prepayment,
  getContent: getContentDetails,
  getPaymentReceipt,
  getAuthPaymentReceipt
};

async function postPaymentProcessing(
  orderData,
  razorPayData,
  accountData
) {
  let accountInfo = JSON.stringify(accountData).replace(/"([^("")"]+)":/g,"$1:");
  let paymentDateTime=moment().format()

  let APIquery =
    `query{postPaymentDetailsRazorPay(input:{
      RequestInput:{      
      Accounts:`+accountInfo+`,  
      paymentDateTime:"`+paymentDateTime+`"    
      orderId:"`+orderData?.id+`",      
      razorpay_payment_id:"`+razorPayData?.razorpay_payment_id+`",      
      razorpay_signature:"`+razorPayData?.razorpay_signature+`"      
      PaymentType:"RAZORPAY_PAYMENT"      
          }      
      })}`;
  return new Promise((resolve, reject) => {
    axios({
      url: config.urls.USAGE_SERVICE_BASE_URL,
      method: "post",
      data: {
        query: APIquery,
      },
    })
      .then(function(response) {
        resolve(response);
      })
      .catch(function(error) {
        reject(error);
      });
  });
}

async function prepayment(amount,accountData) {
  let APIquery =
  `query{prePaymentDetailsRazorPay(input:{RequestInput:{accountId:`+accountData+`,PaymentType:"RAZORPAY_PAYMENT",amount:`+amount+`}})}`;
  return new Promise((resolve, reject) => {
    axios({
    url: config.urls.USAGE_SERVICE_BASE_URL,
      method: "post",
      data:{
         query:APIquery,
      }
    })
      .then(function(response) {
        resolve(response.data);
      })
      .catch(function(error) {
        reject(error);
      });
  });
}

async function getContentDetails(languageCode) {
  let APIquery =
    `query{
        getContents(input:{categoryCode:"INITIATE_PAYMENT",languageCode:"` +
    languageCode +
    `"})
        }`;
  return new Promise((resolve, reject) => {
    axios({
      url: config.urls.ADMIN_SERVICE_BASE_URL,
      method: "post",
      data: {
        query: APIquery,
      },
    })
      .then(function (response) {
        resolve(response.data);
      })
      .catch(function (error) {
        reject(error);
      });
  });
}
async function getPaymentReceipt(accountId, languageCode, amount,transactionDate,customerNumber,payId) {
  let APIquery = `query{
    getBase64DocumentAuthClient(input:{documentCode:"PAYMENT_RECEIPT",
  accountId:"${accountId}",
  customerNumber:"${customerNumber}",
  paymentDate:"${transactionDate}",
  amountPaid:"${amount}",
  tenantCode:"${config.parameters.TENANT_CODE}",
  languageCode:"${languageCode}",
  billId:"",
  payId:"${payId}"})
}`;
return new Promise((resolve, reject) => {
  axios({
    url: config.urls.USAGE_SERVICE_BASE_URL,
    method: "post",
    data: {
      query: APIquery,
    },
  })
    .then(function (response) {
        resolve(response.data);
      })
    .catch(function (error) {
        reject(error);
      });
  });
}

async function getAuthPaymentReceipt(paymenteventId) {
  let APIquery =`query{  getAuthPaymentReceipt }` 
  return new Promise((resolve, reject) => {
  axios({
    url: config.urls.USAGE_SERVICE_BASE_URL,
    method: "post",
    data: {
      query: APIquery,
    },
    headers: {
      "paymenteventId": paymenteventId
    }
  })
    .then(function (response) {
        resolve(response.data);
      })
    .catch(function (error) {
        reject(error);
      });
  });
}
